import {useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {Routes} from "../../../common/Routes";
import {useEffect} from "react";
import {AuthzErrors} from "../../../common/errors";

export function useHandleInvalidUserGroup(userGroupUniqueName) {
    const INVALID_USER_GROUP_KEY = "USER_GROUP_NOT_FOUND";
    const userGroupDetailsError = new AuthzErrors(useSelector(
        (rootState) => rootState.userGroup.userGroupDetails[userGroupUniqueName]?.error
    ) ?? []);

    const history = useHistory()

    useEffect(() => {
        if (userGroupDetailsError.hasKey(INVALID_USER_GROUP_KEY)) {
            history.push(
                Routes.NotFound.path,
                {
                    reason: `User Group with given name "${userGroupUniqueName}" does not exist in the system`
                },
            )
        }
    }, [userGroupDetailsError])
}